export default __webpack_public_path__ + "static/media/Copy of token-05.62e3783c.png";